import { Directive, Input, OnInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[getFocus]'

})
export class FocusDirective implements OnInit {
  @Input('getFocus') isFocused: boolean;

  constructor(private hostElement: ElementRef) {}

  ngOnInit() {
    if (this.isFocused) {
      this.hostElement.nativeElement.focus();
    }
  }
}